import { render } from "./CategoryList.vue?vue&type=template&id=e2c4d34c&scoped=true&ts=true"
import script from "./CategoryList.vue?vue&type=script&lang=ts"
export * from "./CategoryList.vue?vue&type=script&lang=ts"

import "./CategoryList.vue?vue&type=style&index=0&id=e2c4d34c&scoped=true&lang=scss"

import exportComponent from "/var/www/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2c4d34c"]])

export default __exports__